// Vaibhav SIngh: 20-12-23:BT-107427 Removed everthing to screeners diretly: Start
import { memo } from 'react';
import { Screeners } from '../../Screeners';


const SideScreener = ({ isExpanded, setIsExpanded, setActiveMenu, setToggleSideContainer, ...props }) => {//BT- 112339:Watchlist||Side Tray | Closing functionality: ManasaB: 30/06/23
    return (    
        <>    
            <Screeners setActiveMenu={setActiveMenu} isExpanded={isExpanded} setIsExpanded={setIsExpanded} setToggleSideContainer={setToggleSideContainer}/>
        </>     
    );
};

export default memo(SideScreener);
// Vaibhav SIngh: 20-12-23: BT-107427: Removed everthing to screeners diretly: End